import { memo, useCallback, useMemo } from 'react'

import { IContact } from 'clickNgo/entities/contact'
import { ReassignmentItem } from 'clickNgo/features/contact/contactReassignment'
import { Nullable } from 'cng-common/models/utils'

import { ContactRelinkingStep } from '../../../configs'
import { useReassignment } from '../../../contexts/ReassignmentContext'
import { ContactRelinkingStepProps } from '../../../models'
import { contactRelinkingModalTranslations } from '../../../translation'
import { Reassignment } from '../../reassignment'

export const ReassignFlagsStep = memo<ContactRelinkingStepProps>(({ onCancel, onProceed }) => {
  const { flagsToReassign, updateFlagAssignment, availableContacts } = useReassignment()

  const items: ReassignmentItem[] = useMemo(
    () =>
      flagsToReassign.map((flag) => ({
        key: flag.flag.code,
        displayName: flag.flag.code,
        contact: flag.contact || null,
      })),
    [flagsToReassign]
  )

  const handleProceedClick = useCallback(() => {
    onProceed(ContactRelinkingStep.Completion)
  }, [onProceed])

  const handleFlagChange = useCallback(
    (flagKey: string, contact: Nullable<IContact>) => {
      updateFlagAssignment(flagKey, contact)
    },
    [updateFlagAssignment]
  )

  return (
    <Reassignment
      title={contactRelinkingModalTranslations.reassignFlagsStep.title}
      description={contactRelinkingModalTranslations.reassignFlagsStep.description}
      warningMsg={
        availableContacts.length
          ? contactRelinkingModalTranslations.reassignFlagsStep.warning
          : contactRelinkingModalTranslations.reassignFlagsStep.notAvailableContacts
      }
      items={items}
      onItemChange={handleFlagChange}
      onCancel={onCancel}
      onProceed={handleProceedClick}
      isSkippable
    />
  )
})

ReassignFlagsStep.displayName = 'ReassignFlagsStep'

ReassignFlagsStep.displayName = 'ReassignFlagsStep'
